<template>
  <AsyncComp v-bind="$attrs" :key="locale">
    <template v-for="slot in Object.keys($slots)" v-slot:[`${slot}`]>
      <slot :name="slot" />
    </template>
  </AsyncComp>
</template>

<script setup lang="ts">
import { defineAsyncComponent, provide, toRefs } from "vue";
import UpmNotFound from "@src/widgets/UpmNotFound/NotFound.vue";

// Props

const props = withDefaults(
  defineProps<{
    darkMode?: boolean;
    debug?: boolean;
    as: string;
    locale?: string;
  }>(),
  {
    darkMode: false,
    debug: false,
    as: "",
    locale: "en",
  }
);

// Destructured Props (Keeping Reactivity)

const { locale } = toRefs(props);

// Components

const AsyncComp = defineAsyncComponent({
  loader: () =>
    import(`@src/widgets/Upm${props.as}/${props.as}.vue`)
      .then((m) => m.default)
      .catch((error) => {
        console.warn(`Widget '${props.as}' could not be found.`);
        return UpmNotFound;
      }),
  errorComponent: UpmNotFound,
  delay: 0,
});

// Provide

provide("locale", locale);
</script>
